// src/modules/components/reports/calls/CallReportsCharts.js
import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import {
  PieChart,
  ChartsTooltip,
  PieArcLabel,
} from "@mui/x-charts";
import { Stack } from "@mui/material";
import { FiberManualRecord as DotIcon } from "@mui/icons-material";
// import CustomLegend from "./CustomLegend";

const CallReportsCharts = ({ charts, theme }) => {
  const dispositionChartData = charts?.callsByDisposition?.map((item, index) => ({
    id: index,
    label: item.disposition,
    value: parseInt(item.count) || 0,
    color: item.disposition === "ANSWERED" ? theme.palette.success.main :
           item.disposition === "NO ANSWER" ? theme.palette.warning.main :
           item.disposition === "BUSY" ? theme.palette.warning.light :
           theme.palette.error.main,
  })) || [];

  const callTypeChartData = charts?.callsByType?.map((item, index) => ({
    id: index,
    label: item.type || "Unknown",
    value: parseInt(item.count) || 0,
    color: theme.palette.primary.main,
  })) || [];

  return (
    <Grid container spacing={3}>
      {/* Disposition Distribution */}
      <Grid item xs={12} lg={6}>
        <Card elevation={3} sx={{ height: "100%" }}>
          <CardContent>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Call Disposition
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <Box sx={{ height: 300 }}>
                  {dispositionChartData.length > 0 ? (
                    <PieChart
                      series={[
                        {
                          data: dispositionChartData,
                          innerRadius: 40,
                          outerRadius: 100,
                          paddingAngle: 5,
                          cornerRadius: 5,
                          highlightScope: {
                            faded: "global",
                            highlighted: "item",
                          },
                          faded: {
                            innerRadius: 30,
                            additionalRadius: -30,
                            color: "gray",
                          },
                        },
                      ]}
                    >
                      <ChartsTooltip />
                      <PieArcLabel />
                    </PieChart>
                  ) : (
                    <Alert severity="info">
                      No disposition data available
                    </Alert>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomLegend data={dispositionChartData} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {/* Call Type Distribution */}
      <Grid item xs={12} lg={6}>
        <Card elevation={3} sx={{ height: "100%" }}>
          <CardContent>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Call Types
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <Box sx={{ height: 300 }}>
                  {callTypeChartData.length > 0 ? (
                    <PieChart
                      series={[
                        {
                          data: callTypeChartData,
                          innerRadius: 40,
                          outerRadius: 100,
                          paddingAngle: 5,
                          cornerRadius: 5,
                          highlightScope: {
                            faded: "global",
                            highlighted: "item",
                          },
                          faded: {
                            innerRadius: 30,
                            additionalRadius: -30,
                            color: "gray",
                          },
                        },
                      ]}
                    >
                      <ChartsTooltip />
                      <PieArcLabel />
                    </PieChart>
                  ) : (
                    <Alert severity="info">
                      No call type data available
                    </Alert>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomLegend data={callTypeChartData} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CallReportsCharts;

// Custom Legend Component
export const CustomLegend = ({ data }) => {
  return (
    <Box sx={{ py: 2 }}>
      {data.map((item, index) => (
        <Stack key={index} direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
          <DotIcon sx={{ color: item.color, fontSize: 16 }} />
          <Typography variant="body2">
            {item.label}: {item.value}
          </Typography>
        </Stack>
      ))}
    </Box>
  );
};